<div class="card">
    <div class="section-header">
        <h2 class="section-title">{{ 'profileExperience.experience' | translate }}</h2>
        <button class="add-btn" (click)="openAddModal()" *ngIf="mode=='edit'">{{ 'profileExperience.add' | translate
            }}</button>
    </div>

    <!-- Experience List -->
    <div class="experience-list" *ngIf="experience && experience.length > 0">
        <div class="exp-item" *ngFor="let exp of experience; let i = index; let last = last" [class.last]="last">
            <div class="exp-logo" [class.active]="!exp.endDate">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" />
                    <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                </svg>
            </div>

            <div class="exp-content">
                <div class="exp-top">
                    <div>
                        <h3 class="exp-title">{{ exp.title }}</h3>
                        <p class="exp-meta">{{ exp.company }} · {{ exp.location }}</p>
                        <p class="exp-meta">{{ getPeriod(exp) }}</p>
                    </div>
                    <div class="exp-actions" *ngIf="mode=='edit'">
                        <button class="icon-btn" [title]="'profileAbout.edit' | translate"
                            (click)="openEditModal(exp, i)">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                            </svg>
                        </button>
                        <button class="icon-btn icon-btn-delete" [title]="'profileExperience.delete' | translate"
                            (click)="deleteExperience(i)">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="3 6 5 6 21 6"></polyline>
                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path>
                                <path d="M10 11v6"></path>
                                <path d="M14 11v6"></path>
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <p class="exp-description" *ngIf="exp.description">{{ exp.description }}</p>
            </div>
        </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!experience || experience.length === 0 &&  mode=='edit'">
        <p class=" empty-text">
            {{ 'profileExperience.addWorkExperience' | translate }}
        </p>
    </div>
    <div *ngIf="!experience || experience.length === 0 && mode=='view'">
        <p class="empty-text">
            {{ 'profileExperience.addWorkcomapnyExperience' | translate }}
        </p>
    </div>
</div>

<!-- Add / Edit Modal — outside .card -->
<div class="modal-overlay" *ngIf="isModalOpen && mode=='edit'" (click)=" closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">

        <button class="close-btn" (click)="closeModal()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
        </button>

        <div class="modal-header">
            <h3 class="modal-title">{{ isEditing ? ('profileExperience.editExperience' | translate) :
                ('profileExperience.addExperience' | translate) }}</h3>
        </div>

        <div class="modal-body">
            <form [formGroup]="expForm">

                <!-- Row 1: Title and Company -->
                <div class="form-row">
                    <div class="form-group">
                        <label for="title">{{ 'profileExperience.jobTitle' | translate }} <span
                                class="required">*</span></label>
                        <input id="title" type="text" formControlName="title" class="form-input"
                            placeholder="e.g. Senior Developer" />
                        <span class="field-error"
                            *ngIf="expForm.get('title')?.invalid && expForm.get('title')?.touched">
                            Required
                        </span>
                    </div>
                    <div class="form-group">
                        <label for="company">{{ 'profileExperience.company' | translate }} <span
                                class="required">*</span></label>
                        <input id="company" type="text" formControlName="company" class="form-input"
                            placeholder="e.g. Tech Corp" />
                        <span class="field-error"
                            *ngIf="expForm.get('company')?.invalid && expForm.get('company')?.touched">
                            Required
                        </span>
                    </div>
                </div>

                <!-- Row 2: Location -->
                <div class="form-row">
                    <div class="form-group full-width">
                        <label for="location">{{ 'profileExperience.location' | translate }}</label>
                        <input id="location" type="text" formControlName="location" class="form-input"
                            placeholder="e.g. San Francisco, CA" />
                    </div>
                </div>

                <!-- Row 3: Start and End Date -->
                <div class="form-row">
                    <div class="form-group">
                        <label for="startDate">{{ 'profileExperience.startDate' | translate }} <span
                                class="required">*</span></label>
                        <input id="startDate" type="date" formControlName="startDate" class="form-input" />
                        <span class="field-error"
                            *ngIf="expForm.get('startDate')?.invalid && expForm.get('startDate')?.touched">
                            Required
                        </span>
                    </div>
                    <div class="form-group">
                        <label for="endDate">{{ 'profileExperience.endDate' | translate }}</label>
                        <input id="endDate" type="date" formControlName="endDate" class="form-input"
                            [class.disabled]="isCurrent" [attr.disabled]="isCurrent ? true : null"
                            placeholder="End date" />
                    </div>
                </div>

                <!-- Currently working here checkbox -->
                <div class="form-group full-width checkbox-row">
                    <label class="checkbox-label">
                        <input type="checkbox" formControlName="current" class="checkbox-input" />
                        <span>{{ 'profileExperience.currentlyWorkHere' | translate }}</span>
                    </label>
                </div>

                <!-- Description -->
                <div class="form-group full-width">
                    <label for="description">{{ 'profileExperience.description' | translate }}</label>
                    <textarea id="description" formControlName="description" class="form-textarea"
                        placeholder="Describe your responsibilities and achievements..." rows="4"></textarea>
                </div>

            </form>

            <div class="modal-actions">
                <button class="btn btn-cancel" (click)="closeModal()">{{ 'profileExperience.cancel' | translate
                    }}</button>
                <button class="btn btn-save" (click)="saveExperience()" [disabled]="isSaving">
                    <span *ngIf="!isSaving">{{ isEditing ? ('profileExperience.saveChanges' | translate) :
                        ('profileExperience.addExperience' | translate) }}</span>
                    <span *ngIf="isSaving">{{ 'profileExperience.saving' | translate }}</span>
                </button>
            </div>
        </div>

    </div>
</div>